import actionsGlobalActions from "./actions";

export default {
  namespaced: true,
  actions: actionsGlobalActions,
};
